// @ts-nocheck
import React from 'react';
import { ThemeProvider } from '@mui/material';
import Loader from 'components/atoms/Loader';
import { createModifiedTheme } from '../Theme';
import useStatusConfirm from '../hooks/useStatusConfirm';
import LinkExpired from '../LinkExpired';
// import EmailConfirm from './EmailConfirm';
import SignPortal from '../SignPortal';

const emailExternalTheme = createModifiedTheme();

const ViewPortal = () => {
  const { isExpired, loading, emailParam } = useStatusConfirm();
  // const [showSignPortal, setShowSignPortal] = React.useState(false);

  let content;
  if (loading) {
    content = <Loader />;
  } else if (isExpired) {
    content = <LinkExpired />;
  } else {
    content = <SignPortal />;
  }

  return <ThemeProvider theme={emailExternalTheme}>{content}</ThemeProvider>;
};

export default ViewPortal;
